<script>
import { onMounted } from '@vue/composition-api'
import getCountDown from './countdown'
import { EXTRA_TIME } from './constant'
export default {
  props: {
    event: Object
  },
  setup(props, { root, refs, emit }) {
    // 显示时长为生产平台实际配置时长单位秒+3s反馈时长
    const { realCountdown, start } = getCountDown(EXTRA_TIME)
    onMounted(() => {
      const { event } = props
      // 普通红包倒计时不取生产系统配置的，写死
      start(
        8,
        () => {
          // 真正的倒计时结束结束
          emit('realEnd', event)
        },
        () => {
          // 没有额外添加时长的倒计时结束
          emit('end', event)
        }
      )
    })
    return {
      realCountdown
    }
  }
}
</script>
<template>
  <div class="normal-red">
    <div class="red-img" />
    <p class="count-down">
      {{ realCountdown }}S关闭
    </p>
  </div>
</template>
<style lang="less" scoped>
.normal-red {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .red-img {
    width: 300px;
    height: 325px;
    background: url("../images/redbag.png") center no-repeat;
    background-size: auto 100%;
  }
  .count-down {
    text-align: center;
    margin-top: 25px;
    color: #fff;
    font-size: 16px;
  }
}
</style>
